<div class="container section">

  <div class="row pagetitle-row">
    <div class="pagetitle">
      <div class="nav-icons checkout"></div>
      <h1 class="checkout">Summary and Checkout</h1>
    </div>
  </div>

  <div id="contentwrap" class="FlowupLabels">
    <div id="content" class="acepCart">

      <form class="full-width" novalidate>

        <div class="row membership-items" *ngIf="orderdetails.orderLineItems">
          <h3>Membership</h3>
          <div class="row header-row">
            <div class="col-xs-8">Description</div>
            <div class="col-xs-2">Type</div>
            <div class="col-xs-2">Amount</div>
          </div>
          <div class="row" *ngFor="let li of orderdetails.orderLineItems | lineItemsByProductSubType :  'MEMBERSHIP'">
            <div class="col-xs-8">{{li.ProductName}}</div>
            <div class="col-xs-2" *ngIf="li.ProductSubType == ProductSubType.NationalDues; else elseBlock">National</div>
            <ng-template #elseBlock>
              <div class="col-xs-2">
                <a [routerLink]="['/chapters']">Chapters</a>
              </div>
            </ng-template>
            <div class="col-xs-2">{{li.UnitPrice | currency:'USD':'symbol-narrow':'1.2-2'}}</div>
          </div>
        </div>


        <div class="row optional-items checkoutCtr" *ngIf="orderdetails.orderLineItems">
          <h3>Optional</h3>
          <!-- <div class="row checkoutCtr">
            <div class="col-md-8">&nbsp;</div>
            <div class="col-md-2">&nbsp;</div>
            <div class="col-md-2">&nbsp;</div>
          </div> -->
          <div class="row" *ngFor="let li of orderdetails.orderLineItems | lineItemsByProductSubType :  'OPTIONAL'">
            <div class="col-md-8">
              <div class="checkboxWrap">
                <input data-validate="false" id="{{li.ProductNumber}}" name="selectProduct" [(ngModel)]="li.Selected" type="checkbox" (ngModelChange)="updateOrder()">
                <label for="{{li.ProductNumber}}">{{li.ProductName}} </label>
              </div>
            </div>
            <div class="col-md-2">
              <a *ngIf="li.ProductSubType == ProductSubType.SECT" [routerLink]="['/sections']">Section</a>
              <a *ngIf="li.ProductSubType == ProductSubType.ChapterDues" [routerLink]="['/chapters']">Chapters</a>
              {{li.ProductNumber == 'EAAL' ? 'EMRA' : ''}}
            </div>


            <div class="col-md-2" *ngIf="!li.Modifiable || li.ProductSubType == ProductSubType.SECT ; else elsePriceBlock">{{( li.Selected ? li.UnitPrice : 0 )| currency:'USD':'symbol-narrow':'1.2-2'}}</div>

            <ng-template #elsePriceBlock>
              <div class="col-md-2">
                $
                <input class="pricebox numeric" type="text" name="proce_{{li.ProductNumber}}" [(ngModel)]="li.UnitPrice" [disabled]="!li.Selected" (ngModelChange)="updateOrder()" (blur)="updatePriceFormat()">

              </div>
            </ng-template>
          </div>
        </div>



        <div class="row">
          <h3>Checkout</h3>
          <div class="row no-BootstrapCtr checkoutCtr">

            <payment #payment (updatePaymentSummary)="updatePaymentSummary($event)" (OrderProcessingCompleted)="OrderProcessingCompleted($event)" [od]="orderdetails" [pconfig]="paymentuiconfig">
              <div class="payment-check-details">
                <!--Please submit your checks to ACEP Technologies Services Dept....-->
              </div>
              <div class="payment-autorenewal-details">
                <!--The subscription autorenews every year until you cancel!!!!-->
              </div>
            </payment>
          </div>
        </div>

        <hr>

        <div class="row">
          <h3>Terms & Conditions</h3>
          <div class="checkoutCtr">
            <div id='termsContent' [innerHtml]="termsAndConditionsText">
            </div>
            <div class="validationwrap">
              <div class="checkboxWrap">
                <input data-validate="true" id="agreeToTerms" name="saveCC" type="checkbox" required="required">
                <label for="agreeToTerms">I agree to the above Terms & Conditions</label>
                <span class="validationhead">Please agree to our Terms &amp; Conditions</span>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <div class="row actions">
          <div class="col-md-12">
            <button mat-raised-button class="btn btn-primary" (click)="submitpayment($event)">Submit</button>
          </div>
        </div>

      </form>

    </div>
  </div>

</div>

<!-- <pre>
    <code>

        PAYMENT SERVICE: ORDER DETAILS
        {{paymentservice.orderdetails | json}}

    </code>
  </pre>  -->
